import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { spacing, font, colors } from '../../config';

const answerLabelWrapperStyle = css({
  display: 'flex',
  alignItems: 'baseline',
});

const answerLabelTextStyle = css({
  fontSize: font.size.size05,
  marginRight: spacing.size2,
  whiteSpace: 'pre-wrap',
});

const answerLabelScoreStyle = css({
  fontWeight: font.weight.bold,
  fontSize: font.size.sizeM1,
  fontStyle: 'italic',
});

const answerLabelScoreWarningStyle = css({
  fontWeight: font.weight.bold,
  fontSize: font.size.sizeM1,
  fontStyle: 'italic',
  backgroundColor: colors.utilityColors.warning.warning100,
  color: colors.neutralColors.black,
});

const AnswerLabel = ({ labelText, score, scoreWarning }) => (
  <span css={answerLabelWrapperStyle}>
    <span css={answerLabelTextStyle}>{labelText}</span>
    {typeof score === 'number' && (
      <span
        css={
          scoreWarning ? answerLabelScoreWarningStyle : answerLabelScoreStyle
        }
      >
        {`(${score}%)`}
      </span>
    )}
  </span>
);

AnswerLabel.propTypes = {
  labelText: PropTypes.string.isRequired,
  score: PropTypes.number,
  scoreWarning: PropTypes.bool,
};

export { AnswerLabel };
